import { TApplicationState } from 'shared/types/redux';

export const firstBuilderSelector = (state: TApplicationState) => {
  return state.newbuilding.builders[0];
};
